
import { ValidationSet } from '../../../types/validation';
import { hasMatchingBrackets } from '../string';
import { variableScope } from './variable-scope';

export const isVariableRegex = new RegExp('^{{\\b(' + variableScope + ')\\.\\w+\\b}}$');

export const isVariableRules: ValidationSet = {
  condition: (value: string) => /{|}/.test(value),
  rules: [
    {
      message: 'This field can only contain a number or a variable inside double curly braces. Eg: {{app.variable}}',
      test: (value: string) => {
        return !isVariableRegex.test(value.trim());
      }
    },
    {
      message: 'Curly braces are not properly opened or closed',
      test: (value: string) => !hasMatchingBrackets(value)
    }
  ]
};
